<template>
  <div
    class="phone"
    ref="phone"
  >
    <a
      type="primary"
      @click="showModal"
    >
      {{ pswTitle }}
    </a>
    <a-modal
      :title="pswTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      cancel-text="取消"
      ok-text="确定"
      :get-container="()=>$refs.phone"
    >
      <!-- 密码 -->
      <a-spin
        :spinning="spinPassword"
        v-if="pswType === '1'"
      >
        <div>
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 20px;
            position: relative;"
          >
            <span
              style="width: 80px;
              text-align: right;
              margin-right: 14px;"
            >原始密码</span><a-input-password
              v-model="oldPwd"
              placeholder="请输入原始密码"
              style="width: 330px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div>
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 20px;
            position: relative;"
          >
            <span
              style="width: 80px;
              text-align: right;
              margin-right: 14px;"
            >新密码</span><a-input-password
              v-model="newPwd"
              placeholder="8至16位字符，至少1位数字和1字母组合"
              style="width: 330px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div>
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 64px;
            position: relative;"
          >
            <span
              style="width: 80px;
              text-align: right;
              margin-right: 14px;"
            >确认新密码</span><a-input-password
              v-model="conNewPwd"
              placeholder="再次输入新密码"
              style="width: 330px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div>
        </div>
      </a-spin>
      <a-spin
        :spinning="spinPassword"
        v-if="pswType === '0'"
      >
        <div>
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 20px;
            position: relative;"
          >
            <span
              style="width: 80px;
              text-align: right;
              margin-right: 14px;"
            >密码</span><a-input-password
              v-model="newPwd"
              placeholder="8至16位字符，至少1位数字和1个大写字母组合"
              style="width: 330px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div>
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 64px;
            position: relative;"
          >
            <span
              style="width: 80px;
              text-align: right;
              margin-right: 14px;"
            >确认密码</span><a-input-password
              v-model="conNewPwd"
              placeholder="再次输入密码"
              style="width: 330px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { modifyPassword, setPassword } from '@/api/user/user.js';
export default {
  name: 'PhoneNumber',
  props: {
    pswType: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      pswTitle: '修改密码',
      oldPwd: '',
      newPwd: '',
      conNewPwd: '',
      visible: false, // 弹窗显示
      confirmLoading: false, // 按钮加载
      spinPassword: false, // 加载
    };
  },
  mounted() {
    if (this.pswType === '1') {
      this.pswTitle = '修改密码';
    } else {
      this.pswTitle = '设置密码';
    }
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.spinPassword = true;
      this.confirmLoading = true;
      if (this.pswType === '1') {
        modifyPassword({ pwdOld: this.oldPwd, pwdNew: this.newPwd, pwdConfirm: this.conNewPwd }).then(res => {
          if (res.data.status === 'SUCCESS') {
            this.visible = false;
            this.spinPassword = false;
            this.confirmLoading = false;
            this.$message.success('修改密码成功！');
            this.$parent.$parent.info();
          } else {
            this.spinPassword = false;
            this.confirmLoading = false;
            this.$message.warning(res.data.errorMsg);
          }
        });
      } else {
        setPassword({ pwdNew: this.newPwd, pwdConfirm: this.conNewPwd }).then(res => {
          if (res.data.status === 'SUCCESS') {
            this.visible = false;
            this.spinPassword = false;
            this.confirmLoading = false;
            this.$message.success('设置密码成功！');
            this.$parent.$parent.info();
          } else {
            this.spinPassword = false;
            this.confirmLoading = false;
            this.$message.warning(res.data.errorMsg);
          }
        });
      }

    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.phone {
  /deep/ .ant-modal-header {
    border: none;
  }
  /deep/ .ant-modal-footer {
    border: none;
    height: 76px;
    background-color: #F7FAFF;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px;
  }
  /deep/ .ant-spin-container {
    padding-top: 40px;
    border-top: 1px solid #EBF2F7;
  }
  /deep/ .ant-btn {
    width: 100px;
    height: 36px;
    border-radius: 3px;
    border: 1px solid #007CE2;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-top: 10px;
    color: #007CE2;
  }
  /deep/ .ant-btn-primary {
    background: #007CE2;
    color: #fff;
    margin-right: 14px;
    margin-left: 20px;
  }
}
</style>
